/**
* @description 验证模块
*
* @author Barry
* @email barry.li@jwis.cn
*/

export default {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  email (rule, value, callback) {
    if (/^[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?$/.test(value)) {
      callback()
    } else {
      callback(new Error(`${rule.message}`))
    }
  },
  mobile (rule, value, callback) {
    if (/^(13|14|15|16|17|18|19)[0-9]{9}$/.test(value)) {
      callback()
    } else {
      callback(new Error(`${rule.message}`))
    }
  },

  sms (rule, value, callback) {
    if (/^\d{6}$/.test(value)) {
      callback()
    } else {
      callback(new Error(`${rule.message}`))
    }
  }
}
